import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import DropZone from 'react-dropzone'
import './style.styl'

const ImagePreview = ({ preview, className, shouldRenderPreview }) => {
  if (!shouldRenderPreview) {
    return null
  }
  if (preview) {
    return (
      <div
        className={classNames('UIDropArea__Preview', className)}
        style={{
          backgroundImage: `url(${preview})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
    )
  } else {
    return (
      <div className={classNames('UIDropArea__DefaultPreview', className)}>
        <img className="preview" src={require('images/svg/placeholder-image.svg')} alt="preview" />
      </div>
    )
  }
}

class UIDropArea extends Component {
  static propTypes = {
    onDrop: PropTypes.func.isRequired,
    preview: PropTypes.string,
  }

  render() {
    const { onDrop, preview, className, previewClassName, children, shouldRenderPreview = true, disabled = false } = this.props
    return (
      <div className="UIDropAreaContainer">
        <DropZone
          ref={c => (this.dropzone = c)}
          onDrop={onDrop}
          multiple={false}
          activeClassName="active"
          className={classNames('UIDropArea', className)}
          disabled={disabled}
        >
          <ImagePreview preview={preview} onClick={this.handleOpen} className={previewClassName} shouldRenderPreview={shouldRenderPreview} />
          {children}
        </DropZone>
        {this.renderClear()}
      </div>
    )
  }

  renderClear() {
    const { preview, onClear, shouldRenderClear = true } = this.props
    if (preview && shouldRenderClear) {
      return <a className="UIDropArea__Clear" onClick={onClear}>Clear</a>
    }
  }

  handleOpen = e => {
    e.preventDefault()
    this.dropzone.open()
  }
}

export default UIDropArea



// WEBPACK FOOTER //
// ./src/scripts/components/shared/UIDropArea/index.js